const DEFAULT_SHADE = 500
const MAX_SHADE = 900

const getParsedColor = (color) => {
    const parts = color.split('-')
    const family = parts[0]
    const shade = parts[1] === 'base' || !parts[1] ? DEFAULT_SHADE : Number(parts[1])

    return { family, shade }
}

const getHoverColor = (color, colors) => {
    const { family, shade } = getParsedColor(color)
    const palette = colors[family]

    if (!palette) return color

    const availableShades = Object.keys(palette)
        .map(Number)
        .filter((value) => !Number.isNaN(value))
        .sort((a, b) => a - b)

    const nextShade = availableShades.find((value) => value > shade) || Math.min(Math.max(shade, DEFAULT_SHADE), MAX_SHADE)

    return palette[nextShade] || palette[MAX_SHADE] || palette.base
}

/**
 *
 */
const style = (t) => {
    const { colors, typography } = t['foundations-library']
    const coloring = {}

    for (const family of Object.keys(colors)) {
        coloring[`&.link--${family}`] = {
            color: colors[family].base,
            '&:hover': {
                color: getHoverColor(family, colors)
            }
        }
        coloring[`&.link--${family}-base`] = {
            color: colors[family].base,
            '&:hover': {
                color: getHoverColor(`${family}-base`, colors)
            }
        }

        for (const shade of Object.keys(colors[family])) {
            if (shade === 'base') continue
            coloring[`&.link--${family}-${shade}`] = {
                color: colors[family][shade],
                '&:hover': {
                    color: getHoverColor(`${family}-${shade}`, colors)
                }
            }
        }
    }

    return {
        link: {
            ...typography.body1,
            display: 'inline',
            textDecoration: 'underline',
            textUnderlineOffset: '2px',
            transition: 'color 50ms linear',
            cursor: 'pointer',
            ...coloring
        }
    }
}

export {
    getHoverColor
}

export default style
